import { useState } from 'react';
import {
  VariantDescriptionFilterContainer,
  VariantDescriptionFilterContent,
  VariantDescriptionFilterHeading,
} from '../../VariantDescription/VariantDescription.styles';
import DropDown from '../../Dropdown';
import VariantOptionModal from '../../VariantOptionModal';
import { IS_DESKTOP } from '@/utils/checkClientDeviceType';
import { CaratIcon } from '../../../../../assets/svgExports/CaratIcon';
import { roundnessCalculator } from '../../../../../components/DesignSystem/AtomicComponents/util';

function VariantDropdown({
  item = {},
  index,
  returnIsVariantVisible,
  returnIsVariantAvailable,
  activeVariantOptions,
  handleVariantBtnClick,
  storeInfo,
}) {
  const [showVariantOptionModal, setShowVariantOptionModal] = useState(false);
  const activeVariantGroup =
    item && Object.keys(item)?.length > 0 ? Object.keys(item)[0] : '';
  const customVariantList = item[activeVariantGroup];
  const menus = customVariantList?.map((variant) => {
    return {
      value: variant?.variant_name,
      text: variant.variant_name,
      visible: returnIsVariantVisible(variant?.variant_name, index),
      available: returnIsVariantAvailable(variant?.variant_name, index),
    };
  });

  function getSelectedValueForMobile() {
    const selectedOption = menus.find(
      (item) => item.value === activeVariantOptions[index]
    );
    const maxAllowedLength = selectedOption?.available ? 30 : 20;
    const trimmedText =
      selectedOption?.text?.length > maxAllowedLength
        ? `${selectedOption?.text?.substring(0, maxAllowedLength)}...`
        : selectedOption?.text;
    if (!selectedOption?.available) {
      return <span className="tw-text-[#999999]">{`${trimmedText} (Out of stock)`}</span>;
    }
    return <span>{trimmedText}</span>;
  }

  return (
    <VariantDescriptionFilterContainer key={`variant-category-${activeVariantGroup}`}>
      <VariantDescriptionFilterHeading>
        {activeVariantGroup}
      </VariantDescriptionFilterHeading>
      <VariantDescriptionFilterContent style={{ width: '100%', marginTop: '10px' }}>
        {IS_DESKTOP ? (
          <DropDown
            menus={menus}
            selected={activeVariantOptions[index]}
            onChange={(e) => handleVariantBtnClick(index, e.target.value, true)}
            style={{ width: '100%', maxHeight: '210px', overflow: 'scroll' }}
            borderRadius={roundnessCalculator(storeInfo?.theme?.roundness)}
            storeThemeColor={storeInfo?.theme?.colors?.primary_color}
          />
        ) : (
          <div
            className="tw-mr-[16px] tw-flex tw-w-full tw-items-center tw-justify-between tw-border tw-border-solid tw-border-[#D5D5D5] tw-px-[16px] tw-py-[12px] tw-text-sm tw-font-medium"
            onClick={() => setShowVariantOptionModal(true)}
            style={{
              borderRadius: roundnessCalculator(storeInfo?.theme?.roundness),
            }}
          >
            {getSelectedValueForMobile()}
            <CaratIcon
              style={{
                transform: showVariantOptionModal ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
            />
          </div>
        )}
      </VariantDescriptionFilterContent>
      {showVariantOptionModal && (
        <VariantOptionModal
          activeVariantGroup={activeVariantGroup}
          variantOptions={menus}
          onClose={() => setShowVariantOptionModal(false)}
          onClick={(variantName) => handleVariantBtnClick(index, variantName, true)}
          activeVariantOption={activeVariantOptions[index]}
        />
      )}
    </VariantDescriptionFilterContainer>
  );
}

export default VariantDropdown;
